import type { FaireProductEntity } from "../../entity_types/product";

export const p_4v0s6g6qbj: FaireProductEntity = {
  token: "p_4v0s6g6qbj",
  type: "product",
  name: "Owl's Howl Organic Espresso, 12 oz",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/34568ead88068473adad0b53e10868104c0fa758fac843dc840a597f9edac133.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bac7760c4adca906f970838ad517c6496cf5db0396c9d565b649c75715fb558.png",
    "https://cdn.faire.com/fastly/e9d71021f2fdb4f03cb227ab97c8d57708fe82d6f307993b8951f4feef8aab94.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
  ],
  priceDollars: 12.15,
  description:
    "Organic Owl's Howl Espresso // While components and flavors change seasonally, this espresso roast invariably delivers a balanced and refined experience. We rotate the components that comprise this blend throughout the year to ensure optimal freshness, giving us the opportunity to showcase beautiful coffees that pair well together.\nTaste Notes // Cacao Nib, Stone Fruit, Candied Orange Peel\nRoast Profile // Medium-dark\nRecommended Brew Methods // Espresso, Aeropress, French Press\nShelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 60 days of the printed date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note on here or email [redacted-email]!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:12.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
